<template>
  <div class="page--full value bg-dark-white">
    <div class="value__wrapper">
      <!-- <transition name="fadeInUp"> -->
      <h1 class="header__wrapper" v-if="showContentByPaging">
        <span class="header">Our values</span>
      </h1>
      <!-- </transition> -->
      <!-- <transition name="fadeInUp"> -->
      <carousel
        v-if="showContentByPaging"
        :perPageCustom="[[992, 3], [1200, 4]]"
        :paginationEnabled="false"
        :navigationEnabled="true"
        :scrollPerPage="false"
        navigationPrevLabel=""
        navigationNextLabel=""
      >
        <slide v-for="(item, index) in values" :key="index">
          <div class="value-item">
            <img class="value-item__image" :src="item.src" :alt="item.alt" />
            <div class="value-item__content">
              <h2 v-html="item.title" />
              <p>{{ item.text }}</p>
            </div>
          </div>
        </slide>
        <slide v-if="windowWidth < 500">
          <div class="carousel__padding"></div>
        </slide>
      </carousel>
      <!-- </transition> -->
    </div>
  </div>
</template>

<script>
import contentAnimation from '@/mixins/contentAnimation';

export default {
  mixins: [contentAnimation],
  created() {
    this.windowWidth = window.innerWidth;
  },
  data() {
    return {
      values: [
        {
          src: require('@/assets/images/value/personal-ownership.svg'),
          alt: 'Personal Ownership',
          title: 'Personal<br/>Ownership',
          text:
            'We fully own our projects, products, and company. Nothing is "not our job". We are each empowered to identify problems and opportunities, as well as solutions.',
        },
        {
          src: require('@/assets/images/value/continuous-learning.svg'),
          alt: 'Growth and Learning',
          title: 'Growth and<br/>Learning',
          text:
            'When in doubt, we seek the choices that allow us to grow the fastest, as both individuals as well as a company. We emphasize learning as a never-ending pursuit.',
        },
        {
          src: require('@/assets/images/value/open-clear-communication.svg'),
          alt: 'Open and Effective Communication',
          title: 'Open and Effective<br/>Communication',
          text:
            'We are thoughtful about how we communicate, both verbal and written (documentation), to ensure everyone can move confidently in the same direction. ',
        },
        {
          src: require('@/assets/images/value/fun.svg'),
          alt: 'Fun',
          title: 'Fun',
          text:
            'We don’t take ourselves too seriously. We have fun. We laugh and are playful, even when struggling with big challenges.',
        },
        {
          src: require('@/assets/images/value/earn-trust.svg'),
          alt: 'Earn Trust',
          title: 'Earn Trust',
          text:
            'With each other and partners, we strive to earn trust through quality work, respectful interactions, and overall reliability.',
        },
        {
          src: require('@/assets/images/value/user-first-excellence.svg'),
          alt: 'User First<br/>Excellence',
          title: 'User First Excellence',
          text:
            'We focus on making users happy. Whenever possible, we get user feedback, with a focus on data and primary research.',
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.value {
  padding: 9rem 2rem;
  overflow: hidden;
  @media (min-width: $sm) {
    padding: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
  @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
    (max-width: $xs) {
    padding-top: 5rem;
  }
  &__wrapper {
    min-width: 30rem;
    @media (min-width: $sm) {
      padding: 0 12%;
    }
    @media (min-width: $xl) {
      padding: 0 10%;
    }
  }
}

.header {
  &__wrapper {
    margin: 0;
    margin-bottom: 3rem;
    @media (min-width: $sm) {
      font-size: 2.25rem;
    }
    @media (min-width: $xl) {
      font-size: 4rem;
    }
    @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
      (max-width: $xs) {
      margin-bottom: 2rem;
    }
  }
}

.value-item {
  margin-right: 2.25rem;
  @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
    (max-width: $xs) {
    margin-right: 1.25rem;
  }
  &__image {
    margin-bottom: 2rem;
    @media (min-width: $general-iphone-width) and (max-width: $sm) and (min-aspect-ratio: $general-aspect-ratio),
      (max-width: $xs) {
      margin-bottom: 0.6rem;
    }
  }
  &__content {
    padding-left: 2rem;
    h2 {
      font-weight: 500;
      margin-bottom: 1rem;
      @media (min-width: $sm) {
        font-size: 1.5rem;
        line-height: 1.17;
      }
      @media (min-width: $xl) {
        font-size: 2rem;
        line-height: 1.31;
      }
    }
    p {
      opacity: 0.7;
      @media (min-width: $sm) {
        font-size: 0.875rem;
      }
      @media (min-width: $xl) {
        font-size: 1.25rem;
      }
    }
  }

  .carousel {
    &__padding {
      width: 10rem;
      height: 10rem;
    }
  }
}

.fadeInUp-enter-active {
  animation: fadeInUp 0.5s;
}
.fadeInUp-leave-active {
  animation: fadeInUp 0.5s reverse;
}
</style>
